import { useWatch } from 'antd/lib/form/Form'
import { useSubmittalTrackerContext } from '../../../../../SubmittalTrackerContext'
import { FormInstance } from 'antd/es/form/Form'
import { useEffect, useState } from 'react'

/**
 * watches the comment and disposition type to determine whether the comment
 * should be required or not
 *
 * @param form
 */
export function useRequireCommentByDisposition(form: FormInstance) {
  const { dispositionRequiresComment } = useSubmittalTrackerContext()
  const dispositionType = useWatch('dispositionType', form)
  const [required, setRequired] = useState(true)
  const comment = useWatch('comment', form)
  useEffect(() => {
    const required = dispositionRequiresComment(dispositionType?.value)
    // eslint-disable-next-line react-hooks/set-state-in-effect -- Stop-gap for existing behavior.
    setRequired(required)
    if (!required && !comment) form.resetFields(['comment'])
  }, [dispositionRequiresComment, dispositionType?.value, form, comment])
  return {
    /**
     * whether the comment is required
     */
    required,
  }
}
